import React from "react";
import { Link } from "react-router-dom";
import {
  LegalLayout,
  LegalH2,
  LegalP,
  LegalUl
} from "../components/landing/LegalLayout";
import { useLang } from "../i18n/LanguageContext";
import NutzerbedingungenEn from "./en/NutzerbedingungenEn";

export default function Nutzerbedingungen() {
  const { lang } = useLang();
  if (lang === "en") return <NutzerbedingungenEn />;
  return (
    <LegalLayout
      testId="page-nutzerbedingungen"
      title="Nutzungsbedingungen"
      subtitle="Nutzungsbedingungen für die App «WasGitsHüt?» der Liberox GmbH."
    >
      <LegalP>Stand: 21. September 2026</LegalP>

      <LegalH2>1. Anbieter und Geltungsbereich</LegalH2>
      <LegalP>
        Diese Nutzungsbedingungen regeln die Verwendung der mobilen Applikation
        WasGitsHüt? und der damit verbundenen Dienste. WasGitsHüt? wird von der
        Liberox GmbH mit Sitz in der Schweiz angeboten.
      </LegalP>
      <LegalP>
        Mit der Erstellung eines Kontos oder der Nutzung von WasGitsHüt? erklärst
        du dich mit diesen Nutzungsbedingungen einverstanden. Soweit einzelne
        Funktionen über den Apple App Store oder Google Play angeboten werden,
        gelten zusätzlich die jeweiligen Bedingungen der betreffenden Plattform.
      </LegalP>

      <LegalH2>2. Zweck und Funktionen der App</LegalH2>
      <LegalP>
        WasGitsHüt? unterstützt Personen und Haushalte bei der Planung, Auswahl
        und Zubereitung von Mahlzeiten. Je nach aktueller Version können
        insbesondere folgende Funktionen angeboten werden:
      </LegalP>
      <LegalUl
        items={[
          "personalisierte Rezeptvorschläge",
          "gemeinsame Abstimmungen innerhalb eines Haushalts",
          "Verwaltung von Vorlieben, Abneigungen, Ernährungsweisen und Allergien",
          "Erkennung von Zutaten anhand von Bildern",
          "Favoriten und gespeicherte Rezepte",
          "Einkaufslisten",
          "Kochmodus und Schritt-für-Schritt-Anleitungen",
          "Anzeige von Nährwertinformationen",
          "Auswahl verschiedener Küchen und Essenskulturen",
          "Standortfunktionen zur Suche nach Geschäften in der Umgebung",
          "durch künstliche Intelligenz unterstützte Inhalte und Rezeptvorschläge"
        ]}
      />
      <LegalP>
        Der konkrete Funktionsumfang kann je nach Betriebssystem, App-Version,
        Region und gewähltem Abonnement variieren.
      </LegalP>

      <LegalH2>3. Benutzerkonto</LegalH2>
      <LegalP>
        Für wesentliche Funktionen von WasGitsHüt? ist ein Benutzerkonto
        erforderlich. Die Registrierung kann abhängig von der verfügbaren
        App-Version beispielsweise über eine E-Mail-Adresse, Apple oder Google
        erfolgen.
      </LegalP>
      <LegalP>
        Du bist dafür verantwortlich, deine Zugangsdaten angemessen zu schützen
        und keinen unbefugten Personen Zugang zu deinem Konto zu gewähren. Falls
        du einen Missbrauch oder einen unbefugten Zugriff auf dein Konto
        vermutest, solltest du uns unverzüglich kontaktieren.
      </LegalP>
      <LegalP>
        Personen, die aufgrund ihres Alters oder aus anderen gesetzlichen Gründen
        nicht selbst wirksam in diese Nutzungsbedingungen einwilligen können,
        dürfen WasGitsHüt? nur mit Zustimmung ihrer gesetzlichen Vertretung
        nutzen.
      </LegalP>

      <LegalH2>4. Haushalte und gemeinsame Nutzung</LegalH2>
      <LegalP>
        WasGitsHüt? ermöglicht die gemeinsame Nutzung bestimmter Funktionen
        innerhalb eines Haushalts. Mitglieder eines Haushalts können je nach
        Funktion beispielsweise Abstimmungen, Rezeptentscheidungen,
        Einkaufslisten sowie bestimmte Profileinstellungen anderer
        Haushaltsmitglieder sehen.
      </LegalP>
      <LegalP>
        Wer andere Personen zu einem Haushalt einlädt, ist dafür verantwortlich,
        Einladungen nur an Personen weiterzugeben, die tatsächlich Mitglied des
        betreffenden Haushalts sein sollen. Informationen, die innerhalb eines
        Haushalts geteilt werden, können für andere Mitglieder dieses Haushalts
        sichtbar sein. Nutzer sollten deshalb nur Informationen hinterlegen, die
        für die gemeinsame Nutzung vorgesehen sind.
      </LegalP>

      <LegalH2>5. Nutzerinhalte und Bilder</LegalH2>
      <LegalP>
        Du bleibst grundsätzlich für Inhalte verantwortlich, die du selbst in
        WasGitsHüt? eingibst oder hochlädst. Dazu können beispielsweise Bilder
        von Lebensmitteln, Einkaufslisten, Angaben zu Vorlieben oder weitere
        selbst eingegebene Informationen gehören. Du darfst nur Inhalte
        verwenden, zu deren Nutzung du berechtigt bist.
      </LegalP>
      <LegalP>
        Mit dem Hochladen oder Eingeben von Inhalten räumst du der Liberox GmbH
        das für die Bereitstellung der jeweiligen App-Funktion erforderliche
        Recht ein, diese Inhalte technisch zu speichern, zu verarbeiten und
        darzustellen. Dieses Nutzungsrecht ist auf den Betrieb und die
        Bereitstellung von WasGitsHüt? beschränkt.
      </LegalP>

      <LegalH2>6. Künstliche Intelligenz und automatisch erzeugte Inhalte</LegalH2>
      <LegalP>
        Einzelne Funktionen von WasGitsHüt? verwenden künstliche Intelligenz oder
        andere automatisierte Systeme. Dadurch erzeugte Rezepte, Zutatenlisten,
        Bilder, Mengenangaben, Nährwerte oder Empfehlungen können Fehler
        enthalten. Automatisch erzeugte Inhalte sind deshalb vor der Verwendung
        eigenständig zu prüfen.
      </LegalP>
      <LegalP>
        Wir gewährleisten insbesondere nicht, dass automatisch erzeugte Inhalte
        vollständig, fehlerfrei oder für einen bestimmten persönlichen Zweck
        geeignet sind. Automatisch erzeugte Inhalte können zudem ähnlich oder
        identisch zu Inhalten sein, die anderen Nutzern angezeigt werden. Weitere
        Informationen über die Verarbeitung von Daten im Zusammenhang mit solchen
        Funktionen finden sich in unserer{" "}
        <Link to="/datenschutz" className="font-semibold text-terracotta hover:underline">
          Datenschutzerklärung
        </Link>
        .
      </LegalP>

      <LegalH2>7. Allergien, Unverträglichkeiten und Gesundheit</LegalH2>
      <LegalP>
        WasGitsHüt? ist kein medizinischer oder ernährungsmedizinischer
        Beratungsdienst. Angaben zu Allergien, Unverträglichkeiten,
        Ernährungsweisen oder persönlichen Präferenzen dienen dazu,
        Rezeptvorschläge möglichst passend zu gestalten.
      </LegalP>
      <LegalP>
        Trotz solcher Angaben kann nicht gewährleistet werden, dass ein Rezept
        keine problematischen Zutaten oder Allergene enthält. Du bist deshalb
        selbst dafür verantwortlich, Zutaten, Produktkennzeichnungen und Allergene
        vor dem Verzehr zu kontrollieren.
      </LegalP>
      <LegalP>
        Bei schweren Allergien, medizinisch notwendigen Ernährungsformen oder
        vergleichbaren gesundheitlichen Anforderungen darf nicht ausschliesslich
        auf Angaben oder Vorschläge innerhalb der App vertraut werden. Bei
        gesundheitlichen Fragen sollte eine entsprechend qualifizierte Fachperson
        beigezogen werden.
      </LegalP>

      <LegalH2>8. Nährwerte und Mengenangaben</LegalH2>
      <LegalP>
        Kalorien, Eiweiss, Fett, Kohlenhydrate und andere Nährwertangaben können
        berechnet, geschätzt oder aus verfügbaren Produktinformationen abgeleitet
        werden. Solche Angaben dienen der Orientierung und können von den
        tatsächlichen Werten einer Mahlzeit abweichen. Auch Portionsgrössen,
        Kochzeiten und Zutatenmengen können je nach verwendeten Produkten und
        Zubereitung variieren.
      </LegalP>

      <LegalH2>9. Standort und Informationen über Geschäfte</LegalH2>
      <LegalP>
        Falls du die Standortfunktion verwendest, kann WasGitsHüt? deinen
        Standort nutzen, um beispielsweise Geschäfte in deiner Umgebung
        anzuzeigen. Informationen über Standorte, Öffnungszeiten, Verfügbarkeit
        oder andere Angaben von Geschäften können sich ändern. Wir übernehmen
        daher keine Gewähr dafür, dass Informationen zu Drittanbietern jederzeit
        vollständig oder aktuell sind.
      </LegalP>

      <LegalH2>10. Kostenlose Nutzung und Premium-Funktionen</LegalH2>
      <LegalP>
        WasGitsHüt? kann kostenlos heruntergeladen werden. Bestimmte Funktionen
        können kostenlos nur in begrenztem Umfang verfügbar sein. Aktuell können
        Nutzer beispielsweise eine bestimmte Anzahl kostenloser Kochrunden
        erhalten. Der jeweils geltende kostenlose Funktionsumfang wird innerhalb
        der App angezeigt. Darüber hinaus können kostenpflichtige
        Premium-Funktionen angeboten werden.
      </LegalP>

      <LegalH2>11. Abonnemente</LegalH2>
      <LegalP>
        WasGitsHüt? bietet automatisch verlängernde Abonnemente an. Je nach
        Plattform können insbesondere Abonnemente mit einer Laufzeit von einem
        Monat, sechs Monaten oder einem Jahr verfügbar sein. Der verbindliche
        Preis, die Laufzeit und der konkrete Leistungsumfang werden vor Abschluss
        des Kaufs innerhalb der App und im jeweiligen App Store angezeigt.
      </LegalP>
      <LegalP>
        Abonnemente werden über den Apple App Store oder Google Play abgerechnet.
        Die Liberox GmbH erhält dabei grundsätzlich nicht deine vollständigen
        Kreditkarten- oder Bankdaten.
      </LegalP>

      <LegalH2>12. Automatische Verlängerung</LegalH2>
      <LegalP>
        Ein Abonnement verlängert sich automatisch um die jeweils vereinbarte
        Laufzeit, sofern es nicht gemäss den Regeln des Apple App Store
        beziehungsweise Google Play rechtzeitig gekündigt wird. Die Verwaltung
        und Kündigung des Abonnements erfolgt über das Benutzerkonto der
        jeweiligen Plattform.
      </LegalP>
      <LegalP>
        Eine Kündigung beendet grundsätzlich die automatische Verlängerung.
        Bereits bezahlte Premium-Funktionen bleiben normalerweise bis zum Ende
        der bereits bezahlten Abonnementperiode verfügbar.
      </LegalP>

      <LegalH2>13. Rückerstattungen</LegalH2>
      <LegalP>
        Zahlungen über den Apple App Store oder Google Play werden von der
        jeweiligen Plattform verarbeitet. Anträge auf Rückerstattungen sind
        deshalb grundsätzlich über Apple beziehungsweise Google einzureichen und
        werden nach den dort geltenden Regeln beurteilt. Zwingende gesetzliche
        Rechte der Nutzer bleiben vorbehalten.
      </LegalP>

      <LegalH2>14. Löschung des Kontos und bestehende Abonnemente</LegalH2>
      <LegalP>
        Du kannst dein Benutzerkonto gemäss den innerhalb der App angebotenen
        Möglichkeiten löschen. Die Löschung des WasGitsHüt?-Kontos führt nicht
        automatisch zur Kündigung eines Apple- oder Google-Abonnements. Ein
        bestehendes Abonnement muss deshalb separat über den Apple App Store oder
        Google Play gekündigt werden.
      </LegalP>
      <LegalP>
        Nach der Löschung eines Kontos können Daten gemäss unserer{" "}
        <Link to="/datenschutz" className="font-semibold text-terracotta hover:underline">
          Datenschutzerklärung
        </Link>{" "}
        gelöscht oder für gesetzlich erforderliche Zeiträume aufbewahrt werden.
      </LegalP>

      <LegalH2>15. Familienfreigabe</LegalH2>
      <LegalP>
        Soweit Apple, Google oder eine andere Plattform eine Familienfreigabe für
        ein bestimmtes Abonnement unterstützt, kann ein Abonnement gemäss den
        jeweiligen Plattformregeln mit berechtigten Familienmitgliedern geteilt
        werden. Ob und unter welchen Voraussetzungen eine Familienfreigabe
        möglich ist, richtet sich nach den Einstellungen und Regeln der jeweiligen
        Plattform.
      </LegalP>

      <LegalH2>16. Zulässige Nutzung</LegalH2>
      <LegalP>
        WasGitsHüt? darf nur im Rahmen der vorgesehenen Funktionen verwendet
        werden. Insbesondere ist es untersagt:
      </LegalP>
      <LegalUl
        items={[
          "die App für rechtswidrige oder betrügerische Zwecke zu verwenden",
          "andere Nutzer oder Haushalte unbefugt zu beeinträchtigen",
          "unberechtigt auf Konten, Systeme oder Daten anderer Personen zuzugreifen",
          "Sicherheitsmechanismen zu umgehen",
          "die App oder ihre Infrastruktur vorsätzlich zu stören oder zu überlasten",
          "automatisierte Systeme zur missbräuchlichen Nutzung des Dienstes einzusetzen",
          "Schadsoftware oder vergleichbare schädliche Inhalte zu verbreiten",
          "Rechte Dritter zu verletzen",
          "die App entgegen zwingenden gesetzlichen Bestimmungen zu kopieren, zu verändern oder technisch zu untersuchen"
        ]}
      />
      <LegalP>
        Bei schwerwiegenden oder wiederholten Verstössen können wir den Zugang zu
        einzelnen Funktionen oder zum Benutzerkonto einschränken oder sperren.
      </LegalP>

      <LegalH2>17. Rechte an WasGitsHüt?</LegalH2>
      <LegalP>
        Die App, der Name WasGitsHüt?, das Design, die Software, Grafiken, Texte
        und sonstige von uns bereitgestellte Inhalte sind, soweit anwendbar,
        rechtlich geschützt. Die Nutzung der App verleiht dir kein Eigentum an
        diesen Bestandteilen. Du erhältst ein persönliches, beschränktes und nicht
        übertragbares Recht, WasGitsHüt? entsprechend diesen Nutzungsbedingungen
        zu verwenden.
      </LegalP>

      <LegalH2>18. Verfügbarkeit und Änderungen der App</LegalH2>
      <LegalP>
        Wir bemühen uns um einen zuverlässigen Betrieb von WasGitsHüt?. Eine
        jederzeitige und vollständig störungsfreie Verfügbarkeit kann jedoch nicht
        garantiert werden. Vorübergehende Einschränkungen können insbesondere
        aufgrund von Wartungsarbeiten, technischen Störungen, Sicherheitsmassnahmen
        oder Ausfällen externer Dienste auftreten.
      </LegalP>
      <LegalP>
        Wir können Funktionen weiterentwickeln, verändern, ersetzen oder
        entfernen, sofern dadurch bereits erworbene Rechte und zwingende
        gesetzliche Ansprüche nicht unzulässig beeinträchtigt werden.
      </LegalP>

      <LegalH2>19. Haftung</LegalH2>
      <LegalP>
        Die Nutzung von WasGitsHüt? erfolgt im Rahmen der gesetzlich zulässigen
        Grenzen auf eigene Verantwortung. Die Liberox GmbH haftet uneingeschränkt,
        soweit eine Haftungsbeschränkung gesetzlich nicht zulässig ist.
      </LegalP>
      <LegalP>
        Soweit gesetzlich zulässig, wird die Haftung für leichte Fahrlässigkeit
        sowie für indirekte Schäden und Folgeschäden ausgeschlossen. Eine
        Haftungsbeschränkung gilt insbesondere nicht für vorsätzlich oder grob
        fahrlässig verursachte Schäden oder andere Fälle, in denen eine
        Haftungsbeschränkung gesetzlich ausgeschlossen ist.
      </LegalP>
      <LegalP>
        Bei Rezepten, Allergenen, Ernährungsinformationen und automatisch
        erzeugten Inhalten bleibt die Pflicht des Nutzers zur eigenständigen
        Prüfung bestehen.
      </LegalP>

      <LegalH2>20. Datenschutz</LegalH2>
      <LegalP>
        Die Bearbeitung personenbezogener Daten richtet sich nach unserer
        Datenschutzerklärung. Dort wird insbesondere erläutert, welche Daten
        verarbeitet werden, zu welchen Zwecken dies erfolgt und welche Rechte
        Nutzern zustehen. Die Datenschutzerklärung ist unter folgender Adresse
        verfügbar:{" "}
        <Link to="/datenschutz" className="font-semibold text-terracotta hover:underline">
          https://wasgitshüt.ch/datenschutz
        </Link>
      </LegalP>
      <LegalP>
        Gesundheitsbezogene Angaben können nach Schweizer Datenschutzrecht
        besonders schützenswerte Personendaten darstellen. Für solche Daten gelten
        entsprechend erhöhte Anforderungen an Transparenz und Schutz.
      </LegalP>

      <LegalH2>21. Apple App Store</LegalH2>
      <LegalP>
        Wenn WasGitsHüt? über den Apple App Store bezogen wird, gelten zusätzlich
        folgende Bestimmungen:
      </LegalP>
      <LegalUl
        items={[
          "Der Vertrag über die Nutzung von WasGitsHüt? besteht zwischen dir und der Liberox GmbH und nicht mit Apple.",
          "Apple ist nicht für den Betrieb, Inhalt, Support oder die Wartung von WasGitsHüt? verantwortlich.",
          "Die Nutzung der App ist auf Apple-Geräte und die nach den Apple-Nutzungsregeln zulässige Verwendung beschränkt.",
          "Soweit gesetzlich zulässig, ist die Liberox GmbH und nicht Apple für Ansprüche im Zusammenhang mit der App verantwortlich.",
          "Apple und seine verbundenen Unternehmen gelten im Rahmen der für den App Store erforderlichen Bestimmungen als begünstigte Dritte dieser Nutzungsbedingungen und können entsprechende Bestimmungen durchsetzen.",
          "Zusätzlich gelten die jeweils aktuellen Bedingungen des Apple App Store."
        ]}
      />

      <LegalH2>22. Google Play</LegalH2>
      <LegalP>
        Bei einem Bezug von WasGitsHüt? über Google Play gelten zusätzlich die
        Bedingungen von Google Play. Käufe, Abonnemente, Kündigungen und
        Rückerstattungen können entsprechend den jeweiligen Google-Play-Regeln
        verarbeitet werden.
      </LegalP>

      <LegalH2>23. Änderungen dieser Nutzungsbedingungen</LegalH2>
      <LegalP>
        Wir können diese Nutzungsbedingungen anpassen, wenn dies beispielsweise
        aufgrund neuer Funktionen, gesetzlicher Anforderungen,
        Sicherheitsanforderungen oder wesentlicher Änderungen unseres Angebots
        erforderlich ist. Über wesentliche Änderungen informieren wir in
        angemessener Form. Falls aufgrund einer Änderung eine erneute Zustimmung
        gesetzlich erforderlich ist, werden wir diese Zustimmung einholen.
      </LegalP>

      <LegalH2>24. Anwendbares Recht und Gerichtsstand</LegalH2>
      <LegalP>
        Diese Nutzungsbedingungen unterstehen schweizerischem Recht. Zwingende
        gesetzliche Schutzbestimmungen für Konsumenten bleiben vorbehalten. Soweit
        gesetzlich zulässig und kein zwingender Gerichtsstand besteht, ist
        Gerichtsstand der Sitz der Liberox GmbH.
      </LegalP>
      <LegalP>
        Für Konsumenten können insbesondere zwingende Gerichtsstände am eigenen
        Wohnsitz bestehen, auf die nicht wirksam im Voraus verzichtet werden kann.
        Diese Einschränkung ist gerade bei internationalen Nutzern wichtig.
      </LegalP>

      <LegalH2>25. Schlussbestimmungen</LegalH2>
      <LegalP>
        Sollte eine einzelne Bestimmung dieser Nutzungsbedingungen unwirksam oder
        nicht durchsetzbar sein, bleiben die übrigen Bestimmungen davon
        grundsätzlich unberührt. An die Stelle einer unwirksamen Bestimmung treten
        die anwendbaren gesetzlichen Regelungen. Zwingende Rechte, die Nutzern
        aufgrund anwendbaren Rechts zustehen, werden durch diese
        Nutzungsbedingungen nicht eingeschränkt.
      </LegalP>

      <LegalH2>26. Kontakt</LegalH2>
      <LegalP>
        Bei Fragen zu WasGitsHüt? oder diesen Nutzungsbedingungen kannst du die
        auf unserer Website oder innerhalb der App angegebenen Kontaktmöglichkeiten
        verwenden.
      </LegalP>
      <LegalUl
        items={[
          "Anbieter: Liberox GmbH, Schweiz",
          "Website: https://wasgitshüt.ch"
        ]}
      />
    </LegalLayout>
  );
}
